module.exports = __webpack_public_path__ + "img/lost.5618ce11.gif";